import { Location } from "@angular/common";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { ActivatedRoute, Router } from "@angular/router";
import { LetItGoType } from "@core/models/letitgo-type";
// import { User } from "@models";
import { NgbDate, NgbDateParserFormatter, NgbDateStruct, NgbInputDatepicker, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  AuthService,
  BookedService,
  CompanyService,
  NgxToastrService,
  TravelUtilsService,
  UtilsService,
} from "@services";
import { AppState } from "app/app.reducer";
import * as moment from "moment";
import { Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged, take } from "rxjs/operators";
import swal from "sweetalert2";
import { FlightService } from "../../../core/services/flight.service";
import { TrainService } from "../../../core/services/train.service";
import { DetailsComponent } from "./components/details/details.component";
import { Company, User } from "@core/models";
import { cloneDeep } from 'lodash';
import { UserCardModalComponent } from "@shared/component/user-card-modal/user-card-modal.component";

@Component({
  selector: "app-authorizations",
  templateUrl: "./authorizations.component.html",
  styleUrls: ["./authorizations.component.scss"],
})
export class AuthorizationsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription[] = [];
  authorizations: any[] = [];
  paginatedAuthorizations: any[] = [];
  pageSize: number = 10;
  pageIndex: number = 0;
  totalItems: number = 0;
  type: "booking" | "flight" | "train" | "all";
  status: "request" | "denied" | "accepted" | "no vacancy" | "all";
  userName: string;
  userSurname: string;
  description: string;
  initFromDate: string;
  endFromDate: string;
  initToDate: string;
  endToDate: string;
  params: any = {};
  statusOptions = [];
  typeOptions = [];
  subject: Subject<any> = new Subject<any>();
  hasCleared = false;
  // traducciones
  canLoadFilters = false;
  trUserName: string;
  trUserLastName: string;
  trDescription: string;
  trFromDate: string;
  trToDate: string;
  trComments: string;
  trSelect: string;
  loading: boolean = false;
  isLoading: boolean = false;
  hasPrivileges = false;
  @Input() companyUuid: string;
  canUseResident: any;
  user: any;
  @Input() isCompanyBookeds? = true;
  @Input() typeFromBookeds?: "booking" | "flight" | "train" | "all" = "all";
  @Input() userUuid?: string;
  typeComponent: any[] = [];
  @Output() changeComponentEmit: EventEmitter<any> = new EventEmitter<any>();
  component: any;
  length: number;
  filter = "";
  residentOptions = [
    { value: "none", text: "Ninguno" },
    { value: "CN", text: "Canarias" },
    { value: "CE", text: "Ceuta" },
    { value: "BL", text: "Baleares" },
    { value: "ML", text: "Melilla" },
  ];
  @ViewChild("fromInput") fromInput;
  authorization: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  company: Company;
  travelToAssociate: any;

  fromDate: any;
  toDate: any;
  createdFromDate: any;
  createdToDate: any;
  hoveredDate: NgbDateStruct;
  priceChanged: any;

  @ViewChild("d1") fromToInput: NgbInputDatepicker;
  @ViewChild("d2") createdInput: NgbInputDatepicker;
  @ViewChild("fromToRange", { static: false }) fromToRange!: ElementRef;
  @ViewChild("createdAtRange", { static: false }) createdAtRange!: ElementRef;


  /**
   * Let's initialize our subject for changes event in INPUT fields
   * @param bookedService service where API calls are stored
   * @param translateService service to get i18n values
   * @param ngbDateParser service to parse Ngb dates to strings like values;
   * @param ngxToastrService service to show an alert when the flow is done, either is a succesful result or not
   * @param location: angular location service
   */
  constructor(
    private bookedService: BookedService,
    private flightService: FlightService,
    private trainService: TrainService,
    private translateService: TranslateService,
    private ngbDateParser: NgbDateParserFormatter,
    private ngxToastrService: NgxToastrService,
    private route: ActivatedRoute,
    private store: Store<AppState>,
    private location: Location,
    public utilsService: UtilsService,
    private modalService: NgbModal,
    private authService: AuthService,
    public translate: TranslateService,
    private companyService: CompanyService,
    private router: Router,
    private travelUtilsService: TravelUtilsService

  ) {
    this.utilsService.socket.on("create-booking-authorization", (result) => {
      if (this.authorization && this.authorization.requestData.correlationId === result.correlationId) {
        this.utilsService.loadingHotels = false;
        if ((result.data.type && (result.data.type?.toLowerCase().includes("error") || result.data.type?.toLowerCase().includes("exception"))) || (result.data.bookingStatus && (result.data.bookingStatus?.toLowerCase().includes('unknown') || result.data.bookingStatus?.toLowerCase().includes('error')))) {
          swal.close();
          this.translateService
            .get([
              "common.congrat",
              "authorization.swal.accept-success",
            ])
            .subscribe((response) => {
              swal
                .fire({
                  position: "center",
                  icon: "success",
                  iconColor: "#69C9C1",
                  title: response["common.congrat"],
                  text: response[
                    "authorization.swal.accept-success"
                  ],
                  showConfirmButton: false,
                  timer: 3000,
                })
                .then(() => {
                  let price = 0;
                  let children = 0;
                  let adults = 0;
                  this.authorization.requestData.rooms.forEach((r) => {
                    price += parseFloat(r.totalWithPercentage || r.net);
                    r.paxes.forEach(p => {
                      if (p.type?.toUpperCase() === 'CH') {
                        children++;
                      } else if (p.type?.toUpperCase() === 'AD') {
                        adults++;
                      }
                    })
                  });
                  const bookUuid = result?.data?.uuid
                    ?? result?.data?.booked?.uuid
                    ?? result?.book?.uuid;

                  const body =
                  {
                    hotel: {
                      room: {
                        children: children,
                        adults: adults
                      },
                      totalRooms: this.authorization.requestData?.rooms?.length,
                      name: this.authorization.requestData.hotelName,
                      address: this.authorization.requestData.destinationName
                    },
                    checkIn: moment(
                      this.authorization.requestData.checkIn
                    ).format("DD-MM-YYYY"),
                    checkOut: moment(
                      this.authorization.requestData.checkOut
                    ).format("DD-MM-YYYY"),
                    totalPrice: price,
                  }

                  if (this.authorization.requestData && this.authorization.requestData.comments) {
                    body['comments'] = this.authorization.requestData.comments;
                  }

                  if (this.authorization.requestData && this.authorization.requestData.customCode) {
                    body['customCode'] = this.authorization.requestData.customCode;
                  }

                  if (this.authorization.requestData && this.authorization.requestData.costCenter) {
                    body['costCenter'] = this.authorization.requestData.costCenter;
                  }

                  if (this.authorization.requestData && this.authorization.requestData.rooms && this.authorization.requestData.rooms.length > 0 && this.authorization.requestData.rooms[0].breakfast) {
                    body['breakfast'] = this.authorization.requestData.rooms[0].breakfast;
                  }

                  if (this.authorization?.requestData?.rooms[0]?.boardName) {
                    body['boardName'] = this.authorization.requestData.rooms[0].boardName;
                  }

                  if (this.authorization.requestData && this.authorization.requestData.rooms && this.authorization.requestData.rooms.length > 0 && (this.authorization.requestData.rooms[0].cancellation || this.authorization.requestData.rooms[0].cancellationDate)) {
                    body['cancellation'] = this.authorization.requestData.rooms[0].cancellation;
                    body['cancellationDate'] = this.authorization.requestData.rooms[0].cancellationDate ?? null;
                  }

                  if (this.authorization.requestData?.rooms?.length > 0 && (this.authorization.requestData.rooms[0].roomName || this.authorization.requestData.rooms[0].nameRoom)) {
                    body.hotel.room['roomName'] = this.authorization.requestData.rooms[0].roomName ?? this.authorization.requestData.rooms[0].nameRoom;
                  }

                  if (this.travelToAssociate && this.travelToAssociate.title) {
                    body["project"] = this.travelToAssociate.title || "";
                  }

                  this.utilsService.sendEmailOperations(
                    LetItGoType.hotel,
                    body,
                    this.authorization["userUuid"] ? (Array.isArray(this.authorization["userUuid"]) ? this.authorization["userUuid"][0] : this.authorization["userUuid"]) : null
                  );

                  if (this.travelToAssociate) {
                    if (result?.book) {
                      this.addToTravel(bookUuid, result?.book?.checkIn, result?.book?.checkOut, "booking").then(() => {
                        this.loading = false;
                        this.getAuthorizationList();
                      }).catch(err => {
                        this.loading = false;
                        this.getAuthorizationList();
                      });
                      return;
                    }
                  } else {
                    this.loading = false;
                    this.getAuthorizationList();
                  }
                });
            });
        } else {
          this.translateService
            .get([
              "common.congrat",
              "authorization.swal.accept-success",
            ])
            .subscribe((response) => {
              swal
                .fire({
                  position: "center",
                  icon: "success",
                  iconColor: "#69C9C1",
                  title: response["common.congrat"],
                  text: response[
                    "authorization.swal.accept-success"
                  ],
                  showConfirmButton: false,
                  timer: 3000,
                })
                .then(() => {

                  const bookUuid = result?.data?.uuid
                    ?? result?.data?.booked?.uuid
                    ?? result?.book?.uuid;

                  if (this.travelToAssociate) {
                    const bookingInfo = result?.book ?? result?.data;

                    if (bookingInfo) {
                      const checkIn = bookingInfo?.checkIn;
                      const checkOut = bookingInfo?.checkOut;
                      this.addToTravel(bookUuid, checkIn, checkOut, "booking").then(() => {
                        this.loading = false;
                        this.getAuthorizationList();
                        this.authService.totalAuthorizations--;
                      }).catch(err => {
                        this.loading = false;
                        this.getAuthorizationList();
                        this.authService.totalAuthorizations--;
                      });
                      return;
                    }
                  } else {
                    this.loading = false;
                    this.getAuthorizationList();
                    this.authService.totalAuthorizations--;
                  }
                });
            });
        }
      }
    })
    this.subject
      .pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((s) => {
        // llamada a método que actualiza el objeto params
        this.updateParams(s.param, s.value);
        this.getAuthorizationList();
      });

    this.subscriptions.push(
      this.translateService
        .get([
          "common.bookeds",
          "company.company-detail.request",
          "company.company-detail.authorizations",
        ])
        .subscribe((result) => {
          this.typeComponent = [
            { text: result["common.bookeds"], value: "booked" },
            {
              text: result["company.company-detail.request"],
              value: "request",
            },
            {
              text: result["company.company-detail.authorizations"],
              value: "authorization",
            },
          ];
          this.component = 2;
        })
    );
    this.company = this.router.getCurrentNavigation()?.extras?.state?.company;
  }

  /**
   * Init life cycle, getting i18n translations and making our first call with default values:
   * pending request and booking type
   */
  ngOnInit() {
    this.getTranslations();
    this.status = !this.isCompanyBookeds ? "all" : "request";
    this.type = this.typeFromBookeds !== null ? this.typeFromBookeds : "all";
    this.params["type"] = this.type;
    this.params["status"] = this.status;
    this.getUserType();
    this.getCompany();
  }

  getUserType() {
    this.subscriptions.push(
      this.store.select("auth").subscribe((s) => {
        const st: any = s;
        this.hasPrivileges =
          st.user.type?.toLowerCase() === "employee" ||
            st.user.accessType?.toLowerCase() === "hub" ||
            st.user.accessType?.toLowerCase() === "agency"
            ? true
            : false;
        this.hasPrivileges
          ? (this.companyUuid = this.route.snapshot.paramMap.get("id") || this.companyUuid)
          : st.user.companyUuid;
        this.user = st.user;
        this.getAuthorizationList();
      })
    );
  }

  getCompany(): void {
    const uuid = this.companyUuid || this.user?.company?.uuid;
    if (uuid) {
      this.companyService.getCompany(uuid).subscribe(
        (company: Company) => {
          this.company = company;
        },
        (error) => {
        }
      );
    }
  }

  /**
   * With this method, we get the translations for placeholders in html templates, and the status options array
   */
  getTranslations() {
    this.subscriptions.push(
      this.translateService
        .get([
          "authorization.labels.name",
          "authorization.labels.lastName",
          "authorization.labels.description",
          "authorization.labels.from",
          "authorization.labels.to",
          "authorization.comments",
          "authorization.status.title",
          "authorization.status.denied",
          "authorization.status.accepted",
          "authorization.status.no-vacancy",
          "authorization.status.expired",
          "authorization.status.request",
          "authorization.status.all",
          "authorization.type.booking",
          "authorization.type.flight",
          "authorization.type.train",
          "authorization.type.all",
        ])
        .pipe(take(1))
        .subscribe((result) => {
          // labels in html filters
          this.trUserName = result["authorization.labels.name"];
          this.trUserLastName = result["authorization.labels.lastName"];
          this.trDescription = result["authorization.labels.description"];
          this.trFromDate = result["authorization.labels.from"];
          this.trToDate = result["authorization.labels.to"];
          this.trComments = result["authorization.comments"];
          this.trSelect = result["authorization.status.title"];
          // fill array of status options
          this.statusOptions.push(
            {
              view: result["authorization.status.all"],
              value: "all",
            },
            {
              view: result["authorization.status.request"],
              value: "request",
            },
            {
              view: result["authorization.status.accepted"],
              value: "accepted",
            },
            {
              view: result["authorization.status.denied"],
              value: "denied",
            },
            {
              view: result["authorization.status.expired"],
              value: "no vacancy",
            }
          );
          this.typeOptions.push(
            {
              view: result["authorization.type.all"],
              value: "all",
            },
            {
              view: result["authorization.type.booking"],
              value: "booking",
            },
            {
              view: result["authorization.type.flight"],
              value: "flight",
            },
            {
              view: result["authorization.type.train"],
              value: "train",
            }
          );
          this.canLoadFilters = true;
        })
    );
  }

  /**
   * Call to booking service GET list of authorizations, with the params object updated
   */
  getAuthorizationList() {
    if (this.hasPrivileges) {
      delete this.params["companyUuid"];
      if (this.companyUuid) {
        this.params["companyUuid"] = this.companyUuid;
      }
    } else {
      if (this.companyUuid) {
        this.params["companyUuid"] = this.companyUuid;
      } else {
        this.params["companyUuid"] = this.user.companyUuid || this.route.snapshot.paramMap.get("uuid");
      }
    }
    if (
      this.user &&
      this.user.isGroupAdmin &&
      this.user.accessType?.toLowerCase() !== "company"
    ) {
      this.params["groupRestrictionUuid"] = this.user.groupRestrictionUuid;
    }
    if (this.route.snapshot.paramMap.has("agencyUuid")) {
      delete this.params["companyUuid"];
      this.params["agencyUuid"] =
        this.route.snapshot.paramMap.get("agencyUuid");
    }
    if (this.type?.toLowerCase() === "all") {
      delete this.params["type"];
    }

    if (this.userUuid && this.user.accessType?.toLowerCase() === "employee" || this.route.snapshot.params.uuid) {
      this.params["userUuid"] = this.userUuid;
    }
    if (this.params["status"] === "all") {
      delete this.params["status"];
    }

    this.subscriptions.push(
      this.bookedService.getAuthorization(this.params).subscribe((result) => {
        this.authorizations = result;
        this.totalItems = this.authorizations.length;
        this.updatePaginatedAuthorizations();
        if (this.paginator) {
          this.paginator.firstPage();
        }
        this.length = result.length;
        this.loading = false;
        this.isLoading = false;
        if (this.authorizations && this.authorizations.length > 0 &&
          !this.authorizations.some(
            (authorization) => authorization.status === "request"
          )
        ) {
          this.utilsService.haveRequest = false;
        }
        if (this.authorizations && this.authorizations.length > 0 && this.status === "request") {
          this.authService.totalAuthorizations = this.length;
        }
      })
    );
  }

  updatePaginatedAuthorizations() {
    const start = this.pageIndex * this.pageSize;
    const end = start + this.pageSize;
    this.paginatedAuthorizations = this.authorizations.slice(start, end);
  }

  /**
   * Method triggered when a filter field changes. If it is an INPUT field, it calls our subject.
   * If it is not, it calls directly to our updateParams method and to the API caller method
   * @param param field name
   * @param event field value
   * @see updateParams()
   * @see getAuthorizationList()
   */
  filterParam(param: string, event?) {
    this.pageIndex = 0;
    // this.filter = event!!;
    this.hasCleared = false;
    if (
      param === "userName" ||
      param === "userLastName" ||
      param === "description"
    ) {
      this.subject.next({ param: param, value: event });
    } else {
      this.updateParams(param, event);
      this.getAuthorizationList();
    }
  }

  /**
   * Update the params object. If it is the status case, the value will be the status variable above.
   * @param param field name
   * @param value field value
   */
  updateParams(param: string, value?) {
    const formatDate = (date: any) =>
      moment(this.ngbDateParser.format(date), "DD/MM/YYYY").format("YYYY-MM-DD");

    switch (param) {
      case "userName":
        value === "" ? delete this.params["userName"] : (this.params["userName"] = value);
        break;
      case "userLastName":
        value === "" ? delete this.params["userSurname"] : (this.params["userSurname"] = value);
        break;
      case "status":
        this.status === "all" ? delete this.params["status"] : (this.params["status"] = this.status);
        break;
      case "type":
        this.type?.toLowerCase() === "all" ? delete this.params["type"] : (this.params["type"] = this.type);
        break;
      case "description":
        value === "" ? delete this.params["description"] : (this.params["description"] = value);
        break;
      case "fromDate":
        this.params["initFromDate"] = formatDate(value);
        break;
      case "toDate":
        this.params["endFromDate"] = formatDate(value);
        break;
      case "createdFromDate":
        this.params["initCreatedAt"] = formatDate(value);
        break;
      case "createdToDate":
        this.params["endCreatedAt"] = formatDate(value);
        break;
      case "page":
        this.params["page"] = value.pageIndex + 1;
        break;
      default:
        break;
    }
  }

  /**
   * Clears the params object and call the API service with no params
   */
  clearFilters() {
    this.params = {};
    this.status = "request";
    this.filter = "";

    this.fromDate = null;
    this.toDate = null;
    this.createdFromDate = null;
    this.createdToDate = null;

    delete this.params["initFromDate"];
    delete this.params["endFromDate"];
    delete this.params["initToDate"];
    delete this.params["endToDate"];

    if (this.fromToRange) {
      this.fromToRange.nativeElement.value = "";
    }
    if (this.createdAtRange) {
      this.createdAtRange.nativeElement.value = "";
    }

    this.type = this.typeFromBookeds !== null ? this.typeFromBookeds : "all";
    this.params["type"] = this.type;
    this.params["status"] = this.status;
    if (this.companyUuid !== null) {
      this.params["companyUuid"] = this.companyUuid;
    }

    this.getAuthorizationList();
    this.hasCleared = true;
  }

  redoFilters() {
    this.params = {};
    this.status = "all";
    this.filter = "";
    this.fromInput["nativeElement"]["value"] = "";
    this.type = this.typeFromBookeds !== null ? this.typeFromBookeds : "all";
    this.params["type"] = this.type;
    this.params["status"] = this.status;
    if (this.companyUuid !== null) {
      this.params["companyUuid"] = this.companyUuid;
    }
    this.getAuthorizationList();
    this.hasCleared = true;
  }

  canClean() {
    return (
      this.filter !== "" ||
      this.status !== "request" ||
      this.type !== "all" ||
      (this.fromDate !== null || this.toDate !== null) ||
      (this.createdFromDate !== null || this.createdToDate !== null)
    );
  }

  /**
   * Method triggered when pagination change event is fired
   * @param event pagination change
   */
  onPageChange(event) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.updatePaginatedAuthorizations();
  }

  onPrepareAccept(authorization, action, authorizationUser, companyFromUser, authTravel) {
    this.authorization = authorization
    this.loading = true;
    this.showPaymentCardSelector(authorizationUser, companyFromUser).then((selectedCard) => {
      if (!selectedCard && !this.company.bookedWithoutCard) {
        this.loading = false;
        return;
      }

      this.onAccept(authorization, action, selectedCard, authTravel);
    });
  }

  /**
   * Open sweet alert to accept the request
   * @param authorization the object to accept
   */
  onAccept(authorization, action, selectedCard, authTravel) {
    // const fromD = moment(authorization.fromDate).format("DD/MM/YYYY");
    // const toD = moment(authorization.toDate).format("DD/MM/YYYY");

    this.translateService
      .get([
        "authorization.swal.title.accept",
        "authorization.swal.response",
        "common.confirm",
        "common.cancel",
      ])
      .pipe(take(1))
      .subscribe((transl) => {
        const body: any = {
          response: action ? action : "",
          userUuid: authorization.userUuid,
        };
        if (this.hasPrivileges) {
          body["companyUuid"] = authorization.companyUuid;
        };
        if (this.user.accessType?.toLowerCase() !== 'user' || this.user.type?.toLowerCase() !== 'user') {
          if (this.user.type?.toLowerCase() === 'employee') {
            body["adminAuthorizedUuid"] = this.user.role.uuid ? this.user.role.uuid : null;
          } else {
            body["adminAuthorizedUuid"] = this.user.uuid ? this.user.uuid : null;
          }
        };
        if (selectedCard) {
          body["paymentCard"] = {
            name: selectedCard.name,
            token: selectedCard.token,
          };
        }
        this.isLoading = true;
        switch (authorization.type?.toLowerCase()) {
          case "booking":
            body["travellerUuid"] = authorization.requestData.userUuid || '';
            this.subscriptions.push(
              this.bookedService
                .changeStatusAuthorization(body, authorization.uuid, "accept")
                .subscribe(
                  (result) => {

                  },
                  (err) => {
                    swal.close();
                    if (err.status === 403 && err.error && err.error.message === "Su empresa no dispone de una tarjeta válida, contacte con su administrador") {
                      this.loading = false;
                      this.isLoading = false;
                      this.utilsService.loadingFlights = false;

                      this.translateService.get(["common.card-permission-error"])
                        .pipe(take(1))
                        .subscribe((value) =>
                          this.ngxToastrService.typeInfo(null, value["common.card-permission-error"])
                        );
                    } else {
                      this.translateService
                        .get([
                          "common.congrat",
                          "authorization.swal.accept-success",
                        ])
                        .subscribe((response) => {
                          swal
                            .fire({
                              position: "center",
                              icon: "success",
                              iconColor: "#69C9C1",
                              title: response["common.congrat"],
                              text: response[
                                "authorization.swal.accept-success"
                              ],
                              showConfirmButton: false,
                              timer: 3000,
                            })
                            .then(() => {
                              let price = 0;
                              let children = 0;
                              let adults = 0;
                              authorization.requestData.rooms.forEach((r) => {
                                price += parseFloat(r.totalWithPercentage || r.net);
                                r.paxes.forEach(p => {
                                  if (p.type?.toUpperCase() === 'CH') {
                                    children++;
                                  } else if (p.type?.toUpperCase() === 'AD') {
                                    adults++;
                                  }
                                })
                              });

                              const unavail = err.status === 500 && err.error && err.error.message === "There's a stop sales for the date/s" ? true : false

                              const body =
                              {
                                hotel: {
                                  room: {
                                    children: children,
                                    adults: adults
                                  },
                                  totalRooms: authorization.requestData?.rooms?.length,
                                  name: authorization.requestData.hotelName,
                                  address: authorization.requestData.destinationName
                                },
                                checkIn: moment(
                                  authorization.requestData.checkIn
                                ).format("DD-MM-YYYY"),
                                checkOut: moment(
                                  authorization.requestData.checkOut
                                ).format("DD-MM-YYYY"),
                                totalPrice: price,
                                unavail: unavail
                              }

                              if (authorization.requestData && authorization.requestData.comments) {
                                body['comments'] = authorization.requestData.comments;
                              }

                              if (authorization.requestData && authorization.requestData.customCode) {
                                body['customCode'] = authorization.requestData.customCode;
                              }

                              if (authorization.requestData && authorization.requestData.costCenter) {
                                body['costCenter'] = authorization.requestData.costCenter;
                              }

                              if (authorization.requestData && authorization.requestData.rooms && authorization.requestData.rooms.length > 0 && authorization.requestData.rooms[0].breakfast) {
                                body['breakfast'] = authorization.requestData.rooms[0].breakfast;
                              }

                              if (authorization?.requestData?.rooms[0]?.boardName) {
                                body['boardName'] = authorization.requestData.rooms[0].boardName;
                              }

                              if (authorization.requestData && authorization.requestData.rooms && authorization.requestData.rooms.length > 0 && (authorization.requestData.rooms[0].cancellation || authorization.requestData.rooms[0].cancellationDate)) {
                                body['cancellation'] = authorization.requestData.rooms[0].cancellation;
                                body['cancellationDate'] = authorization.requestData.rooms[0].cancellationDate ?? null;
                              }

                              if (authorization.requestData?.rooms?.length > 0 && (authorization.requestData.rooms[0].roomName || authorization.requestData.rooms[0].nameRoom)) {
                                body.hotel.room['roomName'] = authorization.requestData.rooms[0].roomName ?? authorization.requestData.rooms[0].nameRoom;
                              }

                              if (authTravel && authTravel.title) {
                                body["project"] = authTravel.title || "";
                              }

                              this.utilsService.sendEmailOperations(
                                LetItGoType.hotel,
                                body,
                                authorization["userUuid"] ? (Array.isArray(authorization["userUuid"]) ? authorization["userUuid"][0] : authorization["userUuid"]) : null
                              );
                              this.loading = false;
                              this.getAuthorizationList();
                            });
                        });
                    }
                  }
                )
            );
            this.authService.totalAuthorizations--;
            break;
          case "flight":
            if (this.priceChanged) {
              body.priceChanged = this.priceChanged;
            }
            if(authorization?.requestData?.query?.vyooPriceMap){
              body.vyooPriceMap = authorization?.requestData?.query?.vyooPriceMap;
            }
            this.subscriptions.push(
              this.flightService
                .changeStatusAuthorization(body, authorization.uuid, "accept")
                .subscribe(
                  (r) => {
                    this.translateService
                      .get([
                        "common.congrat",
                        "authorization.swal.accept-success",
                      ])
                      .subscribe((response) => {
                        swal
                          .fire({
                            position: "center",
                            icon: "success",
                            title: response["common.congrat"],
                            text: response[
                              "authorization.swal.accept-success"
                            ],
                            showConfirmButton: false,
                            timer: 3000,
                          })
                          .then(async () => {
                            const travelPromises = [];

                            if (this.travelToAssociate && r.createResponse) {
                              const departDateFormat = moment(r.createResponse.departDate).format("YYYY-MM-DD");
                              let returnDateFormat = r.createResponse.returnDate
                                ? moment(r.createResponse.returnDate).format("YYYY-MM-DD")
                                : undefined;

                              travelPromises.push(
                                this.addToTravel(r.createResponse.uuid, departDateFormat, returnDateFormat, "flight")
                              );

                              if (r.additionalBookings && r.additionalBookings.length > 0) {
                                r.additionalBookings.forEach((element) => {
                                  const departDateFormatExtra = moment(element.departDate).format("YYYY-MM-DD");
                                  let returnDateFormatExtra = element.returnDate
                                    ? moment(element.returnDate).format("YYYY-MM-DD")
                                    : undefined;

                                  travelPromises.push(
                                    this.addToTravel(element.uuid, departDateFormatExtra, returnDateFormatExtra, "flight")
                                  );
                                });
                              }
                            }

                            try {
                              await Promise.all(travelPromises);
                            } catch (err) { }

                            this.loading = false;
                            this.priceChanged = null;
                            this.getAuthorizationList();
                          });
                      });
                  },
                  (err) => {
                    if (err.status === 409 && err.error.error === "Price changed") {
                      const originalAmount = err.error.originalAmount.toFixed(2);
                      const currentAmount = err.error.currentAmount.toFixed(2);
                      const currency = err.error.currency ?? "EUR";

                      const previousPrice = (originalAmount*1 + authorization.requestData.vyooCommission).toFixed(2);
                      const currentPrice = (currentAmount*1 + authorization.requestData.vyooCommission).toFixed(2);

                      authorization.requestData.query.vyooPriceMap = this.updatePriceMap(authorization, currentPrice);
                      authorization.requestData.letItGoInfo.price = currentPrice;
                      authorization.price = currentPrice;
                      authorization.requestData.query.vyooPrice = currentPrice;

                      this.translate
                        .get([
                          "flight.detail-flight.price-changed",
                          "flight.detail-flight.previous-price",
                          "flight.detail-flight.current-price",
                          "flight.detail-flight.change-detected",
                          "project.accept",
                          "common.cancel",
                        ])
                        .subscribe((translations) => {
                          swal.fire({
                            icon: "warning",
                            title: translations["flight.detail-flight.change-detected"],
                            html: `
                                        <p>${translations["flight.detail-flight.price-changed"]}</p>
                                        <p><strong>${translations["flight.detail-flight.previous-price"]}:</strong> ${previousPrice} ${currency}</p>
                                        <p><strong>${translations["flight.detail-flight.current-price"]}:</strong> ${currentPrice} ${currency}</p>
                                    `,
                            showCancelButton: true,
                            confirmButtonText: translations["project.accept"],
                            cancelButtonText: translations["common.cancel"],
                            customClass: {
                              popup: "price-change-popup",
                              confirmButton: "simple-confirm-btn",
                              cancelButton: "simple-cancel-btn",
                            },
                            buttonsStyling: false,
                          }).then((result) => {
                            if (result.isConfirmed) {
                              this.priceChanged = currentPrice;
                              this.onDetails(authorization);
                            } else {
                              this.utilsService.loadingFlights = false;
                            }
                          });
                        });
                      return;
                    }
                    else if (err.status === 403 && err.error && err.error.message === "Su empresa no dispone de una tarjeta válida, contacte con su administrador") {
                      this.loading = false;
                      this.isLoading = false;
                      this.utilsService.loadingFlights = false;

                      this.translateService.get(["common.card-permission-error"])
                        .pipe(take(1))
                        .subscribe((value) =>
                          this.ngxToastrService.typeInfo(null, value["common.card-permission-error"])
                        );
                    } else {
                      const unavail = err.status === 400 && err.error && err?.error?.message?.startsWith('Flight-Wrapper.flightOffersSeach: "ErrorRS: KO - AVAIL_OUT') ? true : false
                      this.translateService
                        .get([
                          "common.congrat",
                          "authorization.swal.accept-success",
                        ])
                        .subscribe((response) => {
                          swal
                            .fire({
                              position: "center",
                              icon: "success",
                              title: response["common.congrat"],
                              text: response[
                                "authorization.swal.accept-success"
                              ],
                              showConfirmButton: false,
                              timer: 3000,
                            })
                            .then(() => {
                              const parsedAncillaries = [];
                              const ancillaries = authorization.requestData.query.ancillaries || '';
                              const { seats, stops, stopsText } = authorization.requestData.letItGoInfo;
                              const body2 = {
                                lleegoBookingID: null,
                                itinerary: authorization.requestData.letItGoInfo.itinerary,
                                dates: `${authorization.requestData.departDate ?? moment(authorization.requestData.departureDate).format('DD/MM/YYYY HH:mm')
                                  } ${authorization.requestData.returnDate
                                    ? moment(authorization.requestData.returnDate).format("DD/MM/YYYY HH:mm")
                                    : ""
                                  }`,
                                price: authorization.requestData.letItGoInfo.price || authorization.price || authorization.requestData.price || authorization.requestData.query.vyooPrice,
                                seats,
                                // baggages: authorization.requestData.query.ancillaries ,
                                travelerList: authorization.requestData.query.travellers,
                                travellers: authorization.requestData.query.travellers.length,
                                stops,
                                stopsText,
                                fares: { fareName: authorization.requestData?.query?.fares?.fareName, fareCondition: authorization.requestData.query?.fares?.fareSelected?.services, price: authorization.requestData.query?.fares?.fareSelected?.total_price },
                                unavail: unavail
                              };

                              if (ancillaries != null && ancillaries.length > 0) {
                                ancillaries.forEach((baggage) => {
                                  {
                                    parsedAncillaries.push({
                                      price: baggage.total,
                                      name: baggage.short_name,
                                    });
                                  }
                                });
                                body2['baggages'] = parsedAncillaries;
                              }
                              if (this.canUseResident) {
                                this.residentOptions.find((r) => {
                                  if (r.value === this.canUseResident) {
                                    body2["canUseResident"] = r.text;
                                  }
                                })
                              }
                              if (authTravel && authTravel.title) {
                                body2["project"] = authTravel.title || "";
                              }

                              this.utilsService.sendEmailOperations(
                                LetItGoType.flight,
                                body2,
                                authorization["userUuid"] ? (Array.isArray(authorization["userUuid"]) ? authorization["userUuid"][0] : authorization["userUuid"]) : null
                              );

                              if (err.error.letItGoBooks && err.error.letItGoBooks.length > 0) {
                                err.error.letItGoBooks.forEach(element => {

                                  if (this.travelToAssociate) {
                                    const departDateFormat = moment(element.departDate).format("YYYY-MM-DD");
                                    let returnDateFormat;

                                    if (element.returnDate) {
                                      returnDateFormat = moment(element.returnDate).format("YYYY-MM-DD");
                                    }

                                    this.addToTravel(element.uuid, departDateFormat, returnDateFormat, "flight").then(() => {
                                      this.loading = false;
                                      this.getAuthorizationList();
                                    }).catch(err => {
                                      this.loading = false;
                                      this.getAuthorizationList();
                                    });
                                    return;
                                  } else {
                                    this.loading = false;
                                    this.getAuthorizationList();
                                  }

                                });
                              } else {
                                this.loading = false;
                                this.getAuthorizationList();
                              }
                            });
                        });
                    }
                    this.priceChanged = null;
                    this.authService.totalAuthorizations--;
                    swal.close();
                    this.loading = false;
                    // this.subscriptions.push(
                    //   this.translateService
                    //     .get("authorization.flight-expired")
                    //     .subscribe((resp) => {
                    //       this.ngxToastrService.typeInfo(
                    //         resp,
                    //         err.error.message
                    //       );
                    //     })
                    // );
                  }
                )
            );
            break;
          case "train":
            this.subscriptions.push(
              this.trainService
                .changeStatusAuthorization(body, authorization.uuid, "accept")
                .subscribe(
                  (r) => {
                    this.translateService
                      .get([
                        "common.congrat",
                        "authorization.swal.accept-success",
                      ])
                      .subscribe((response) => {
                        swal
                          .fire({
                            position: "center",
                            icon: "success",
                            title: response["common.congrat"],
                            text: response[
                              "authorization.swal.accept-success"
                            ],
                            showConfirmButton: false,
                            timer: 3000,
                          })
                          .then(() => {
                            this.loading = false;
                            this.getAuthorizationList();
                          });
                      });
                  },
                  (err) => {
                    if (err.status === 403 && err.error && err.error.message === "Su empresa no dispone de una tarjeta válida, contacte con su administrador") {
                      this.loading = false;
                      this.isLoading = false;
                      this.utilsService.loadingFlights = false;

                      this.translateService.get(["common.card-permission-error"])
                        .pipe(take(1))
                        .subscribe((value) =>
                          this.ngxToastrService.typeInfo(null, value["common.card-permission-error"])
                        );
                    } else {
                      this.translateService
                        .get([
                          "common.congrat",
                          "authorization.swal.accept-success",
                        ])
                        .subscribe((response) => {
                          swal
                            .fire({
                              position: "center",
                              icon: "success",
                              title: response["common.congrat"],
                              text: response[
                                "authorization.swal.accept-success"
                              ],
                              showConfirmButton: false,
                              timer: 3000,
                            })
                            .then(() => {
                              const body2 = {
                                itinerary: `${authorization.requestData.origin} - ${authorization.requestData.destination}`,
                                dates: `${moment(authorization.requestData.departDate).format('DD/MM/YYYY HH:mm')
                                  } ${authorization.requestData.returnDate
                                    ? moment(authorization.requestData.returnDate).format('DD/MM/YYYY HH:mm')
                                    : ""
                                  }`,
                                price: authorization.requestData.price ?? authorization.price,
                                seats: authorization.requestData.seats,
                                travelers: [`${authorization.requestData.passengers[0].name} ${authorization.requestData.passengers[0].firstSurname} ${authorization.requestData.passengers[0].secondSurname ?? ''}`],
                                rates: authorization.requestData.rates,
                                passengers: authorization.requestData.passengers

                              };
                              // if (this.trains.length > 1) {
                              //   body.dates =
                              //     `${this.trains[0].travelDate} ${this.trains[0].departureTime}` +
                              //     " - " +
                              //     `${this.trains[1].travelDate} ${this.trains[1].departureTime}`;
                              // }
                              if (authTravel && authTravel.title) {
                                body2["project"] = authTravel.title || "";
                              }

                              this.utilsService.sendEmailOperations(
                                LetItGoType.train,
                                body2,
                                authorization["userUuid"] ? (Array.isArray(authorization["userUuid"]) ? authorization["userUuid"][0] : authorization["userUuid"]) : null
                              );
                              this.loading = false;
                              this.getAuthorizationList();
                            });
                        });
                    }
                    swal.close();
                    /*this.subscriptions.push(
                      this.translateService
                        .get("authorization.train-expired")
                        .subscribe((resp) => {
                          this.ngxToastrService.typeInfo(
                            resp,
                            err.error.message
                          );
                        })
                    );*/
                  }
                )
            );
            break;
          default:
            break;
        }
      })
    this.loading = false;
    this.authService.totalAuthorizations--;
  }

  /**
   * Open sweet alert to deny the request
   * @param authorization the object to deny
   */
  onDeny(authorization, action) {
    this.loading = true;
    // const fromD = moment(authorization.fromDate).format("DD/MM/YYYY");
    // const toD = moment(authorization.toDate).format("DD/MM/YYYY");
    const body = {
      response: action,
      userUuid: authorization.userUuid
    };
    if (this.hasPrivileges) {
      body["companyUuid"] = authorization.companyUuid;
    };
    if (this.user.accessType?.toLowerCase() !== 'user' || this.user.type?.toLowerCase() !== 'user') {
      if (this.user.type?.toLowerCase() === 'employee') {
        body["adminAuthorizedUuid"] = this.user.role.uuid ? this.user.role.uuid : null;
      } else {
        body["adminAuthorizedUuid"] = this.user.uuid ? this.user.uuid : null;

      }
    };
    this.subscriptions.push(
      this.bookedService
        .changeStatusAuthorization(body, authorization.uuid, "deny")
        .subscribe(
          (result) => {
            this.translateService
              .get(["common.canceled", "authorization.swal.deny-success"])
              .subscribe((response) => {
                swal
                  .fire({
                    position: "center",
                    icon: "error",
                    // iconColor:"#69C9C1",
                    title: response["common.canceled"],
                    text: response["authorization.swal.deny-success"],
                    showConfirmButton: false,
                    timer: 3000,
                  })
                  .then(() => {
                    this.loading = false;
                    this.getAuthorizationList();
                  });
              });
          },
          (err) => {
            swal.close();
            this.subscriptions.push(
              this.translateService.get("common.error").subscribe((resp) => {
                this.ngxToastrService.typeInfo(resp, err.error.message);
              })
            );
          }
        )
    );
    this.authService.totalAuthorizations--;
  }

  onDetails(authorization) {
    const clonedAuthorization = cloneDeep(authorization);
    const fromD = moment(clonedAuthorization.fromDate).format("DD/MM/YYYY");
    let toD;
    if (clonedAuthorization.toDate != null) {
      toD = moment(clonedAuthorization.toDate).format("DD/MM/YYYY");
    }

    const modalRef = this.modalService.open(DetailsComponent, {
      size: "lg",
      centered: true,
      modalDialogClass: "auth-details-component",
    });

    modalRef.componentInstance.authorization = clonedAuthorization;
    modalRef.componentInstance.user = this.user;
    modalRef.componentInstance.fromD = fromD;
    modalRef.componentInstance.toD = toD;
    modalRef.componentInstance.sendInfo.subscribe(
      (r: { deny: any; authorization: any; action: any; loading: boolean; authorizationUser: User, companyFromUser: any, authTravel: any }) => {
        this.isLoading = r.loading;
        if (r.authTravel) {
          this.travelToAssociate = r.authTravel;
        } else {
          this.travelToAssociate = null;
        }
        if (r.deny) {
          this.onDeny(r.authorization, r.action);
          modalRef.close();
        } else {
          this.canUseResident = (r.authorizationUser?.resident && r.authorizationUser?.resident !== "none") ? r.authorizationUser?.resident : undefined;
          this.onPrepareAccept(r.authorization, r.action, r.authorizationUser, r.companyFromUser, r.authTravel);
          modalRef.close();
        }
      }
    );
  }


  showPaymentCardSelector(authorizationUser, companyFromUser): Promise<any> {
    if (companyFromUser.bookedWithoutCard) {
      return Promise.resolve(null);
    }

    if (!Array.isArray(authorizationUser.paymentCards)) {
      authorizationUser.paymentCards = authorizationUser.paymentCards ? [authorizationUser.paymentCards] : [];
    }

    /* if (!Array.isArray(authorizationUser.personalPaymentCards)) {
      authorizationUser.personalPaymentCards = authorizationUser.personalPaymentCards ? [authorizationUser.personalPaymentCards] : [];
    } */

    if ((!authorizationUser.paymentCards || authorizationUser.paymentCards.length === 0) /* && (!authorizationUser.personalPaymentCards || authorizationUser.personalPaymentCards.length === 0) */) {
      this.translate
        .get(["common.no-card-user-error"])
        .pipe(take(1))
        .subscribe((value) =>
          this.ngxToastrService.typeInfo(
            null,
            value["common.no-card-user-error"]
          )
        );
      return Promise.resolve(null);
    }

    return new Promise((resolve) => {
      const modalRef = this.modalService.open(UserCardModalComponent, {
        windowClass: 'custom-modal-user-card',
        centered: true,
        backdrop: 'static',
        keyboard: false
      });
      modalRef.componentInstance.bookCards = authorizationUser.paymentCards;
      /*       modalRef.componentInstance.bookPersonalCards = authorizationUser.personalPaymentCards; */
      modalRef.componentInstance.fromBookSelect = true;
      modalRef.componentInstance.cardSelected.subscribe((selectedCard) => {
        resolve(selectedCard);
      });
      modalRef.result.catch(() => {
        resolve(null);
      });
    });
  }


  onDateSelection(type: string, date: NgbDate) {
    if (type === "fromTo") {
      if (!this.fromDate && !this.toDate) {
        this.fromDate = date;
      } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
        this.toDate = date;
        this.fromToInput.close();
        this.fromToRange.nativeElement.value =
          this.ngbDateParser.format(this.fromDate) +
          " a " +
          this.ngbDateParser.format(this.toDate);
        this.emitDates("fromTo");
      } else {
        this.toDate = null;
        this.fromDate = date;
      }
    } else if (type === "created") {
      if (!this.createdFromDate && !this.createdToDate) {
        this.createdFromDate = date;
      } else if (this.createdFromDate && !this.createdToDate && date.after(this.createdFromDate)) {
        this.createdToDate = date;
        this.createdInput.close();
        this.createdAtRange.nativeElement.value =
          this.ngbDateParser.format(this.createdFromDate) +
          " a " +
          this.ngbDateParser.format(this.createdToDate);
        this.emitDates("created");
      } else {
        this.createdToDate = null;
        this.createdFromDate = date;
      }
    }
  }

  isHovered(date: NgbDate, type: string) {
    if (type === "fromTo") {
      return (
        this.fromDate &&
        !this.toDate &&
        this.hoveredDate &&
        date.after(this.fromDate) &&
        date.before(this.hoveredDate)
      );
    } else {
      return (
        this.createdFromDate &&
        !this.createdToDate &&
        this.hoveredDate &&
        date.after(this.createdFromDate) &&
        date.before(this.hoveredDate)
      );
    }
  }

  isInside(date: NgbDate, type: string) {
    if (type === "fromTo") {
      return date.after(this.fromDate) && date.before(this.toDate);
    } else {
      return (
        date.after(this.createdFromDate) && date.before(this.createdToDate)
      );
    }
  }

  isRange(date: NgbDate, type: string) {
    if (type === "fromTo") {
      return (
        date.equals(this.fromDate) ||
        date.equals(this.toDate) ||
        this.isInside(date, type) ||
        this.isHovered(date, type)
      );
    } else {
      return (
        date.equals(this.createdFromDate) ||
        date.equals(this.createdToDate) ||
        this.isInside(date, type) ||
        this.isHovered(date, type)
      );
    }
  }

  emitDates(type: "fromTo" | "created") {
    if (type === "fromTo") {
      if (this.fromDate) {
        this.updateParams("fromDate", this.fromDate);
      } else {
        delete this.params["initFromDate"];
      }

      if (this.toDate) {
        this.updateParams("toDate", this.toDate);
      } else {
        delete this.params["endFromDate"];
      }
    }

    if (type === "created") {
      if (this.createdFromDate) {
        this.updateParams("createdFromDate", this.createdFromDate);
      } else {
        delete this.params["initToDate"];
      }

      if (this.createdToDate) {
        this.updateParams("createdToDate", this.createdToDate);
      } else {
        delete this.params["endToDate"];
      }
    }

    this.getAuthorizationList();
  }


  addToTravel(itemUuid: any, initDate?: any, endDate?: any, type?: string): Promise<void> {
    if (this.utilsService.hasProcessedUuid(itemUuid)) {
      return Promise.resolve();
    }
    this.utilsService.addProcessedUuid(itemUuid);

    const addBody: any = {
      item: {
        type: type,
        uuid: itemUuid,
        initDate: initDate,
      },
    };

    if (endDate) {
      addBody.item.endDate = endDate;
    }
    return this.travelUtilsService.addItemToTravel(addBody, this.travelToAssociate.uuid);
  }

  updatePriceMap(authorization?: any, currentPrice?: any){
      const travellerData = authorization.requestData.query.travellers;
      const basePrice = currentPrice - Number(authorization.requestData.expectedAmount) - Number(authorization.requestData.baggagesPrice);
      const numTravellers = travellerData.length || 1;
      const basePricePerTraveller = basePrice / numTravellers;
      const pricesPerTraveller: { [uuid: string]: { individualPrice: number, baggagesPrice: number, seatsPrice: number } } = {};

      travellerData.forEach((traveller, index) => {
        let baggagesPrice = 0;
        const travellerBaggages = authorization.requestData.selectedBaggages.filter(
          baggage => baggage.pax_references?.includes(index)
        );
        for (const baggage of travellerBaggages) {
          baggagesPrice += baggage.total;
        }

        const seatsPrice = authorization.requestData.seatsByPassenger?.[traveller.uuid]?.total ?? 0;

        const individualPrice = basePricePerTraveller + baggagesPrice + seatsPrice;

        pricesPerTraveller[traveller.uuid] = {
          individualPrice: parseFloat(individualPrice.toFixed(2)),
          baggagesPrice: parseFloat(baggagesPrice.toFixed(2)),
          seatsPrice: parseFloat(seatsPrice.toFixed(2))
        };
      });
      return pricesPerTraveller;
  }

  /**
   * If there is no results while filtering, reload default table
   * If there is no results after that, go back
   */
  goBack() {
    this.location.back();
  }

  changeComponent(event) {
    this.changeComponentEmit.emit(this.typeComponent[event]);
    this.component = this.typeComponent.indexOf(this.typeComponent[event]);
  }

  /**
   * Last method of life cycle component, where we unsuscribe our subscriptions and subject.
   */
  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
    this.subject.unsubscribe();
  }
}
